// extracted by mini-css-extract-plugin
export default {"root":"sample-video_root__Kxw5C"};